import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { actionSetData, actionResetData, actionGetData } from 'modules/MediaPlanner/store/actions'

export const useMediaPlanner = () => {
  const dispatch = useDispatch()

  const getData = useCallback(
    (props) =>
      new Promise((resolve, reject) =>
        dispatch(
          actionGetData({
            ...props,
            meta: { resolve, reject },
          }),
        ),
      ),
    [],
  )

  const setData = useCallback((props) => dispatch(actionSetData(props)), [])

  const resetData = useCallback((props) => dispatch(actionResetData(props)), [])

  return {
    resetData,
    setData,
    getData,
  }
}
